import React, { useRef } from 'react';
import { cn } from '../../../../classname';
import { ImgSettingsButton } from './ImgSettingsButton';
import './ImgNodeView.css';
export const cnImgSizeNodeView = cn('img-size-node-view');
export const ImageNodeView = ({ node, view, getPos, updateAttributes, }) => {
    const ref = useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement(ImgSettingsButton, { node: node, view: view, getPos: getPos, updateAttributes: updateAttributes, nodeRef: ref }),
        React.createElement("img", Object.assign({}, node.attrs, { ref: ref }))));
};
